import React, { useState } from "react";
import { Link } from "react-scroll";
import { HiMenu, HiX } from "react-icons/hi";

const Navbar = () => {
  const navItem = [
    { id: 1, name: "Home", path: "home" },
    { id: 2, name: "Rooms", path: "rooms" },
    { id: 3, name: "Event Hall", path: "eventHall" },
    { id: 4, name: "Specialties", path: "specialties" },
    { id: 5, name: "About Us", path: "about" },
  ];

  const [active, setActive] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClass = (id) =>
    active === id
      ? "text-white border-b-2 pb-1"
      : "text-white hover:border-b-2 hover:border-white transition";

  return (
    <div className="bg-[#001D33] w-full fixed z-50">
      <div className="flex justify-between items-center px-5 md:px-20 py-5">
        <div className="h-[70px] flex items-center justify-center">
          <img
            src="/assets/sastha-logo-image.svg"
            alt="Sastha Logo"
            className="h-full w-auto object-contain"
          />
        </div>

        <ul className="hidden lg:flex gap-12 items-center">
          {navItem.map((nav) => (
            <li key={nav.id}>
              <Link
                to={nav.path}
                smooth
                spy
                offset={-90}
                duration={500}
                onSetActive={() => setActive(nav.id)}
                className={`${linkClass(nav.id)} cursor-pointer  font-calson font-normal text-[16px]`}
              >
                {nav.name}
              </Link>
            </li>
          ))}

          <Link to="book" smooth spy offset={-90} duration={500}>
            <button className="px-6 py-3 bg-white text-[#001D33] font-calson text-[16px] uppercase">
              Contact Us
            </button>
          </Link>
        </ul>

        <button
          className="lg:hidden text-white text-3xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-[#001D33] px-6 pb-6">
          <ul className="flex flex-col gap-6">
            {navItem.map((nav) => (
              <li key={nav.id}>
                <Link
                  to={nav.path}
                  smooth
                  spy
                  offset={-90}
                  duration={500}
                  onSetActive={() => {
                    setActive(nav.id);
                    setMenuOpen(false);
                  }}
                  className={`${linkClass(nav.id)} cursor-pointer font-calson text-[16px]`}
                >
                  {nav.name}
                </Link>
              </li>
            ))}
            <Link to="book" smooth spy offset={-90} duration={500}>
              <button className="w-full py-3 bg-white text-[#001D33] font-calson text-[16px] uppercase">
                Contact Us
              </button>
            </Link>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
